import { qwanyxCollection } from "qwanyx";

/**
 * Get Atlas Search results using an aggregation pipeline
 * @param {Array} pipeline - The aggregation pipeline, starting with a $search stage
 * @param {number} limit - Maximum number of results to return
 * @returns {Promise<Array>} - Array of results
 */
export async function getASBatch(
    pipeline = [],
    limit = 1000 // Default generous limit
) {
    console.log('getASBatch called with pipeline:', pipeline);
    
    try {
        const collection = qwanyxCollection();
        
        // Create a working copy of the pipeline
        const workingPipeline = [...pipeline];
        
        // If the pipeline doesn't have a $limit stage, add one
        const hasLimitStage = workingPipeline.some(stage => '$limit' in stage);
        if (!hasLimitStage) {
            workingPipeline.push({ $limit: limit });
        }
        
        console.log('Running aggregation pipeline:', JSON.stringify(workingPipeline));
        
        // Execute the aggregation
        const results = await collection.aggregate(workingPipeline);
        
        // Convert results to an array, handling different Realm return types
        let resultsArray = [];
        
        if (Array.isArray(results)) {
            resultsArray = results;
        } else if (results && typeof results.forEach === 'function') {
            results.forEach(item => resultsArray.push(item));
        } else if (results && typeof results[Symbol.iterator] === 'function') {
            for (const item of results) {
                resultsArray.push(item);
            }
        } else if (results && typeof results.length === 'number') {
            for (let i = 0; i < results.length; i++) {
                resultsArray.push(results[i]);
            }
        }
        
        console.log(`Atlas Search returned ${resultsArray.length} results`);
        return resultsArray;
    } catch (error) {
        console.error("Error fetching Atlas Search results:", error);
        throw error;
    }
}